__turbopack_context__.v({
  "account-card": "AccountCard-module-scss-module__pB7JAq__account-card",
  "address": "AccountCard-module-scss-module__pB7JAq__address",
  "customer-number": "AccountCard-module-scss-module__pB7JAq__customer-number",
  "enterprise-number": "AccountCard-module-scss-module__pB7JAq__enterprise-number",
  "info": "AccountCard-module-scss-module__pB7JAq__info",
  "name": "AccountCard-module-scss-module__pB7JAq__name",
});
